<template>
  <div class="process-select-person">
    <el-dialog title="自定义候选人" class="process-custom-select-person-dialog" :visible.sync="dialogVisible" :before-close="cancel" center @open="open()" :close-on-click-modal="false" append-to-body>
      <div class="selected">
        <select-person v-if="selectType==='user'&& dialogVisible" :remoteSearch="true" :treeData="allData" :select="select" ref="select" :isRadio="'radio'" :type="'group'"></select-person>
        <select-single-node v-if="selectType==='component'" :treeData="allData" :select="select" ref="select"></select-single-node>
      </div>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="展示节点">
          <el-select v-model="showNode" multiple collapse-tags>
            <el-option
              v-for="item in getAllNodes"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="required">必填</el-checkbox>
          <label class="explain">(已选择的候选人都可以处理该节点)</label>
        </el-form-item>
      </el-form>
      <div class="buttons">
        <el-button type="primary" @click="save">确定</el-button>
        <el-button @click="cancel">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import SelectPerson from '../../system/select-person'
import SelectSingleNode from '../../system/select-single-node'

export default {
  name: 'ProcessSelectPerson',
  props: ['nodes', 'dialogVisible', 'allData', 'candidates', 'candidateShowNode', 'candidateRequired', 'selectType'],
  components: {
    SelectPerson,
    SelectSingleNode
  },
  data () {
    return {
      showNode: [],
      required: true,
      select: []
    }
  },
  methods: {
    open () {
      this.showNode = this.candidateShowNode ? this.candidateShowNode.split(', ') : []
      this.required = this.candidateRequired
      this.select = this.candidates || []
    },
    save () {
      let select = []
      let radio = this.$refs.select.getDefault()
      this.$refs.select.getSelectedList().forEach(m => {
        select.push({
          'targetId': m.id,
          'name': m.name,
          'type': m.type,
          'defaultValue': radio === m.id
        })
      })
      if (this.showNode.length === 0) {
        this.showNode = ['无']
      }
      this.$emit('saveSelectPerson', {
        'candidateShowNode': this.showNode.join(', '),
        'candidateRequired': this.required,
        'candidates': select
      })
    },
    cancel () {
      this.$emit('closeDialog')
    }
  },
  computed: {
    getAllNodes () {
      if (this.dialogVisible) {
        return this.nodes.filter(m => {
          return m.type !== 'endEvent' && m.type !== 'cancelEvent'
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .process-custom-select-person-dialog {
    .el-dialog {
      height: 475px;
      width: 646px;
      div.el-dialog__header {
        height: 34px;
      }
      div.el-dialog__body {
        height: 100%;
        width: 100%;
        padding: 0 0 0 0;
        .selected {
          margin-top: 19px;
        }
        form.el-form {
          margin-top: 30px;
          padding-left: 61px;
          .el-form-item {
            margin-right: 17px;
            .el-form-item__label {
              font-size: 14px;
            }
            .explain {
              font-size: 12px;
              color: #B3B3B3;
            }
            .el-form-item__content {
              .el-input {
                width: 162px;
              }
              height: 28px;
              .el-select {
                width: 100%;
                height: 100%;
              }
            }
          }
          > div {
            margin-top: 0px;
            padding-left: 0px;
          }
        }
        .buttons {
          text-align: center;
          margin-top: 25px;
          button {
            width: 104px;
            height: 30px;
            span {
              font-size: 16px;
            }
            &:first-child {
              margin-right: 35px;
            }
          }

        }
      }

    }
  }

</style>



// WEBPACK FOOTER //
// src/components/process/design/process-dialog-select-person.vue